import { render, staticRenderFns } from "./msgtypeNews.vue?vue&type=template&id=7aa20973&scoped=true&"
import script from "./msgtypeNews.vue?vue&type=script&lang=js&"
export * from "./msgtypeNews.vue?vue&type=script&lang=js&"
import style0 from "./msgtypeNews.vue?vue&type=style&index=0&id=7aa20973&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa20973",
  null
  
)

export default component.exports